import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBoardingIndicatorBoarded = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 12,
	viewBox: "0 0 14 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M1 9.71938C1 9.98459 1.10536 10.2389 1.29289 10.4265C1.48043 10.614 1.73478 10.7194 2 10.7194H12.188C12.4532 10.7194 12.7076 10.614 12.8951 10.4265C13.0826 10.2389 13.188 9.98459 13.188 9.71938V7.87938C12.7842 7.76943 12.4278 7.52972 12.1738 7.19721C11.9197 6.8647 11.782 6.45784 11.782 6.03938C11.782 5.62091 11.9197 5.21405 12.1738 4.88154C12.4278 4.54903 12.7842 4.30932 13.188 4.19937V2.35938C13.188 2.09416 13.0826 1.8398 12.8951 1.65227C12.7076 1.46473 12.4532 1.35938 12.188 1.35938H2C1.73478 1.35938 1.48043 1.46473 1.29289 1.65227C1.10536 1.8398 1 2.09416 1 2.35938V4.19538C1.4072 4.30272 1.76742 4.54184 2.02446 4.87541C2.28149 5.20899 2.42088 5.61826 2.42088 6.03938C2.42088 6.46049 2.28149 6.86976 2.02446 7.20334C1.76742 7.53691 1.4072 7.77603 1 7.88338V9.71938ZM9.204 1.36738V3.00738V1.36738ZM9.204 5.21937V6.85938V5.21937ZM9.204 9.07938V10.7194V9.07938Z",
			fill: "#40E098"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.204 1.36738V3.00738M9.204 5.21937V6.85938M9.204 9.07938V10.7194M1 9.71938C1 9.98459 1.10536 10.2389 1.29289 10.4265C1.48043 10.614 1.73478 10.7194 2 10.7194H12.188C12.4532 10.7194 12.7076 10.614 12.8951 10.4265C13.0826 10.2389 13.188 9.98459 13.188 9.71938V7.87938C12.7842 7.76943 12.4278 7.52972 12.1738 7.19721C11.9197 6.8647 11.782 6.45784 11.782 6.03938C11.782 5.62091 11.9197 5.21405 12.1738 4.88154C12.4278 4.54903 12.7842 4.30932 13.188 4.19937V2.35938C13.188 2.09416 13.0826 1.8398 12.8951 1.65227C12.7076 1.46473 12.4532 1.35938 12.188 1.35938H2C1.73478 1.35938 1.48043 1.46473 1.29289 1.65227C1.10536 1.8398 1 2.09416 1 2.35938V4.19538C1.4072 4.30272 1.76742 4.54184 2.02446 4.87541C2.28149 5.20899 2.42088 5.61826 2.42088 6.03938C2.42088 6.46049 2.28149 6.86976 2.02446 7.20334C1.76742 7.53691 1.4072 7.77603 1 7.88338V9.71938Z",
			stroke: "#059A41",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgBoardingIndicatorBoarded);
export { ForwardRef as ReactComponent };
